import type { JSX } from "solid-js";
import { spread } from "solid-js/web";

/**
 * A `<video>` that Safari will actually draw. JSX would clone it from a
 * compiled `<template>`, and Safari plays a cloned video's audio but never
 * paints its frames — from an MP4, native HLS, or MSE alike. An element made
 * by `document.createElement` doesn't have the problem, so this one is.
 */
export const Video = (props: JSX.VideoHTMLAttributes<HTMLVideoElement>) => {
	const video = document.createElement("video");
	spread(video, props, false, true);
	return video;
};
